import { combineReducers } from 'redux'
import { NEW_GAME, CHANGE_NEW_CHALLENGE_ID, CHANGE_NEW_CHALLENGE_CONFIG, CHALLENGE_SUBMITTED, SET_MAKE_CHALLENGE_ERROR } from '../actions/ChallengeMaker'

const challengeId = function(state=-1, action) {
  switch (action.type) {
    case CHANGE_NEW_CHALLENGE_ID:
      return action.challengeId
    default:
      return state
  }
}

const config = function(state='', action) {
  switch (action.type) {
    case NEW_GAME:
    case CHANGE_NEW_CHALLENGE_CONFIG:
      return action.config
    default:
      return state
  }
}

const submitted = function(state=false, action) {
  switch (action.type) {
    case CHALLENGE_SUBMITTED:
      return true
    default:
      return state
  }
}

const error = function(state=null, action) {
  switch(action.type) {
    case SET_MAKE_CHALLENGE_ERROR:
      return action.error
    default:
      return state
  }
}

const newChallengeReducer = combineReducers({
  challengeId,
  config,
  submitted,
  error
})

export default newChallengeReducer


// WEBPACK FOOTER //
// ./reducers/newChallenge.js